export const ERROR_PAGE_LABELS = Object.freeze({
  NOT_FOUND: "pageNotFound",
  NO_AUTH: "notAuthenticated",
  NO_ACCESS: "noAccessToPage",
  COMP_ERROR: "componentError",
  SERVER_ERROR: "serverError",
  LOGIN: "/login"
});

export const GO_TO_HOME = "Back Home";
